// Aplica el tema (claro/oscuro/sistema) al documento.
// Tailwind está en darkMode: 'class', así que basta alternar la clase raíz.
export function applyTheme(theme: string | undefined): void {
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const dark =
    theme === 'dark' || ((theme ?? 'light') === 'system' && prefersDark);
  document.documentElement.classList.toggle('dark', dark);
}
